/**
 * Shipping cutoff countdown banner – flip clock version
 * - Counts down to today's cutoff time (e.g. 14:00) on weekdays
 * - Once passed, counts down to tomorrow's cutoff instead
 * - Friday after cutoff and all weekend: counts down to Monday's cutoff
 * - The "[hours] h [minutes] min" part of each translated template is replaced
 *   by a flip clock (HH:MM:SS); the rest of the sentence stays as translated
 * - Uses the customer's browser local time
 */

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.shipping-countdown');
  if (!wrapper) return;

  const textEl = wrapper.querySelector('[data-shipping-countdown-text]');
  if (!textEl) return;

  const cutoffHour = parseInt(wrapper.dataset.cutoffHour, 10) || 14;
  const cutoffMinute = parseInt(wrapper.dataset.cutoffMinute, 10) || 0;
  const templates = {
    today: wrapper.dataset.templateToday || 'Order within [hours] h [minutes] min for shipping today!',
    tomorrow: wrapper.dataset.templateTomorrow || 'Order within [hours] h [minutes] min for shipping tomorrow!',
    monday: wrapper.dataset.templateMonday || 'Order within [hours] h [minutes] min for shipping on Monday!'
  };

  // Matches "[hours] h [minutes] min" (and the unit word after minutes in any language)
  const TIME_PATTERN = /\[hours\][\s\S]*?\[minutes\](\s*min\w*\.?)?/i;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let currentType = null;
  let units = [];

  function getNextMondayCutoff(base) {
    const target = new Date(base);
    const day = target.getDay();
    let daysToAdd;
    if (day === 0) daysToAdd = 1;
    else if (day === 6) daysToAdd = 2;
    else if (day === 5) daysToAdd = 3;
    else daysToAdd = (8 - day) % 7 || 7;
    target.setDate(target.getDate() + daysToAdd);
    target.setHours(cutoffHour, cutoffMinute, 0, 0);
    return target;
  }

  function getNextCutoff() {
    const now = new Date();
    const day = now.getDay();

    if (day === 0 || day === 6) {
      return { target: getNextMondayCutoff(now), type: 'monday' };
    }

    const todayCutoff = new Date(now);
    todayCutoff.setHours(cutoffHour, cutoffMinute, 0, 0);

    if (now < todayCutoff) {
      return { target: todayCutoff, type: 'today' };
    }

    if (day === 5) {
      return { target: getNextMondayCutoff(now), type: 'monday' };
    }

    const tomorrowCutoff = new Date(todayCutoff);
    tomorrowCutoff.setDate(tomorrowCutoff.getDate() + 1);
    return { target: tomorrowCutoff, type: 'tomorrow' };
  }

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function createFlip() {
    const flip = document.createElement('span');
    flip.className = 'scb-flip';
    ['scb-flip__half scb-flip__half--top', 'scb-flip__half scb-flip__half--bottom',
     'scb-flip__flap scb-flip__flap--top', 'scb-flip__flap scb-flip__flap--bottom'].forEach(function (cls) {
      const part = document.createElement('span');
      part.className = cls;
      const num = document.createElement('span');
      num.className = 'scb-flip__num';
      num.textContent = '00';
      part.appendChild(num);
      flip.appendChild(part);
    });
    return { el: flip, value: null };
  }

  function setUnit(unit, value) {
    if (unit.value === value) return;
    const old = unit.value;
    unit.value = value;
    const num = function (cls) { return unit.el.querySelector(cls + ' .scb-flip__num'); };

    if (old === null || reduceMotion) {
      ['.scb-flip__half--top', '.scb-flip__half--bottom', '.scb-flip__flap--top', '.scb-flip__flap--bottom']
        .forEach(function (cls) { num(cls).textContent = value; });
      return;
    }

    num('.scb-flip__half--top').textContent = value;
    num('.scb-flip__half--bottom').textContent = old;
    num('.scb-flip__flap--top').textContent = old;
    num('.scb-flip__flap--bottom').textContent = value;

    unit.el.classList.remove('is-flipping');
    void unit.el.offsetWidth;
    unit.el.classList.add('is-flipping');

    clearTimeout(unit.timer);
    unit.timer = setTimeout(function () {
      num('.scb-flip__half--bottom').textContent = value;
      unit.el.classList.remove('is-flipping');
    }, 580);
  }

  // Builds "text before" + clock + "text after" for the current template
  function build(type) {
    const template = templates[type];
    const match = template.match(TIME_PATTERN);
    textEl.textContent = '';
    units = [];

    if (!match) {
      textEl.textContent = template;
      return;
    }

    const before = template.slice(0, match.index);
    const after = template.slice(match.index + match[0].length);

    const clock = document.createElement('span');
    clock.className = 'scb-clock';
    clock.setAttribute('role', 'timer');

    for (let i = 0; i < 3; i++) {
      if (i > 0) {
        const colon = document.createElement('span');
        colon.className = 'scb-clock__colon';
        colon.setAttribute('aria-hidden', 'true');
        colon.textContent = ':';
        clock.appendChild(colon);
      }
      const unit = createFlip();
      units.push(unit);
      clock.appendChild(unit.el);
    }

    textEl.appendChild(document.createTextNode(before));
    textEl.appendChild(clock);
    textEl.appendChild(document.createTextNode(after));
  }

  function tick() {
    const result = getNextCutoff();
    const diffMs = result.target - new Date();

    if (result.type !== currentType) {
      currentType = result.type;
      build(currentType);
    }

    if (units.length === 3) {
      const total = Math.max(0, Math.floor(diffMs / 1000));
      setUnit(units[0], pad(Math.min(99, Math.floor(total / 3600))));
      setUnit(units[1], pad(Math.floor((total % 3600) / 60)));
      setUnit(units[2], pad(total % 60));
    }

    setTimeout(tick, 1000 - (Date.now() % 1000) + 10);
  }

  tick();
});